import React from "react";
import { Outlet } from "react-router-dom";
import { Footer, Sidebar } from "..";
import { SidebarProvider } from "./SidebarContext";

export default function EmpedanceMainLayout() {
  return (
    <SidebarProvider>
      <div className="admin-shell font-inter min-h-screen text-app-ink">
        <Sidebar />

        <main className="flex p-3 sm:p-4 lg:pl-0">
          <Outlet />
        </main>

        <div className="w-full px-4 pb-4 lg:pl-[17rem]">
          <Footer />
        </div>
      </div>
    </SidebarProvider>
  );
}
